import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  componentDidCatch(err, info) {
    // Surface the real (source-mapped) error in the console for diagnosis.
    console.error("Page error:", err, info?.componentStack);
  }
  componentDidUpdate(prev) {
    // Reset when the parent switches pages (via the `resetKey` prop).
    if (prev.resetKey !== this.props.resetKey && this.state.err) {
      this.setState({ err: null });
    }
  }
  render() {
    if (this.state.err) {
      return (
        <div className="p-8 max-w-lg">
          <h2 className="text-lg font-semibold text-slate-900">Something went wrong on this page.</h2>
          <p className="text-sm text-slate-500 mt-2 break-words">{String(this.state.err?.message || this.state.err)}</p>
          <div className="flex gap-2 mt-4">
            <button onClick={() => this.setState({ err: null })} className="px-4 py-2 rounded-lg text-sm text-white" style={{ backgroundColor: "#4F46E5" }}>Try again</button>
            <button onClick={() => window.location.reload()} className="px-4 py-2 rounded-lg text-sm border border-slate-300 text-slate-700">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
